var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIkAutomatyczne = function SvgIkAutomatyczne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.542
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6406",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#118cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 312",
    cx: 2.544,
    cy: 2.544,
    r: 2.544,
    transform: "translate(12.912 13.454)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 480",
    cx: 2.544,
    cy: 2.544,
    r: 2.544,
    transform: "translate(12.912 .454)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 313",
    cx: 2.544,
    cy: 2.544,
    r: 2.544,
    transform: "translate(0 13)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 481",
    cx: 2.544,
    cy: 2.544,
    r: 2.544
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 274",
    d: "m12.5 17.046-6.732-1.222"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 364",
    d: "m.5 13.046 1.633-7.588"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 365",
    d: "M15.133 13.191 16.5 6.046"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 363",
    d: "m12.5 2.824-7-1.778"
  }))));
};
export default SvgIkAutomatyczne;